import styled from 'styled-components';
import { ReactComponent as Logo } from 'styles/icons/logo.svg';

import { normalize } from 'utils/styles';
import { color, media } from 'styles/settings';
import Button from 'components/button';

export const Container = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  position: fixed;
  top: ${normalize('15px')};
  left: ${normalize('15px')};
  z-index: 2;
`;

export const BrandNameContainer = styled.div`
  background-color: ${color.neutral.white};
  height: ${normalize('20px')};
  padding: ${normalize('17px')};
  border-radius: 10px 2px 2px 2px;
  ${media.mediaQueries.mobile`
    display:none;
  `}
`;

export const BrandLogo = styled(Logo)`
  width: ${normalize('102px')};
  height: ${normalize('20px')};
`;

export const SeparatorContainer = styled.div`
  background-color: ${color.neutral.white};
  height: ${normalize('36px')};
  padding: ${normalize('12px')} 0;
`;

export const Separator = styled.div`
  background-color: #cfcfcf;
  height: ${normalize('36px')};
  width: ${normalize('1px')};
`;
